var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"lazy-background",rawName:"v-lazy-background"}],staticClass:"marquee-background__instance",style:({
    '--marquee-background-image-width': `${_vm.backgroundImageWidth}px`
  }),attrs:{"lazy-background":_vm.backgroundImage.asset.url}},[_vm._v("\n   \n")])
}
var staticRenderFns = []

export { render, staticRenderFns }